import { render } from "./eBooks.vue?vue&type=template&id=59cdca7e"
import script from "./eBooks.vue?vue&type=script&lang=js"
export * from "./eBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__